import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useCallbackPrevention } from '../../internal/hooks/usePreventedEventCallback';
import { InformerModalAction, InformerModalActions, InformerModalActionSecondary, InformerModalBody, InformerModalCloseButton, InformerModalContent, InformerModalDescription, InformerModalFooter, InformerModalMedia, InformerModalRoot, InformerModalTitle } from './InformerModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Предсозданный компонент модального окна типа Informer
 */
export const InformerModal = /*#__PURE__*/React.memo(function InformerModal(_ref) {
  let {
    open,
    onOpenChange,
    portal = true,
    size,
    width,
    onPrimaryAction,
    onSecondaryAction,
    preventOutside,
    preventEscape,
    title,
    description,
    actionText,
    secondaryActionText,
    media,
    hideCloseButton,
    closeButtonProps
  } = _ref;
  const preventCloseByEscape = useCallbackPrevention(preventEscape);
  const preventCloseByOutsideInteraction = useCallbackPrevention(preventOutside);
  return /*#__PURE__*/_jsx(InformerModalRoot, {
    onOpenChange: onOpenChange,
    open: open,
    modal: portal,
    children: /*#__PURE__*/_jsxs(InformerModalContent, {
      size: size,
      overlay: preventOutside ? 'blured' : undefined,
      onEscapeKeyDown: preventCloseByEscape,
      onInteractOutside: preventCloseByOutsideInteraction,
      style: {
        width
      },
      children: [!hideCloseButton && /*#__PURE__*/_jsx(InformerModalCloseButton, _objectSpread({
        theme: "fill_dark",
        size: "XS",
        icon: /*#__PURE__*/_jsx(IconActionClose16, {
          color: "current_color"
        }),
        title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
      }, closeButtonProps)), /*#__PURE__*/_jsxs(InformerModalBody, {
        children: [/*#__PURE__*/_jsx(InformerModalMedia, {
          children: media
        }), /*#__PURE__*/_jsx(InformerModalTitle, {
          children: title
        }), /*#__PURE__*/_jsx(InformerModalDescription, {
          children: description
        })]
      }), /*#__PURE__*/_jsx(InformerModalFooter, {
        children: /*#__PURE__*/_jsxs(InformerModalActions, {
          children: [/*#__PURE__*/_jsx(InformerModalAction, {
            onClick: onPrimaryAction,
            children: actionText
          }), secondaryActionText && onSecondaryAction && /*#__PURE__*/_jsx(InformerModalActionSecondary, {
            onClick: onSecondaryAction,
            children: secondaryActionText
          })]
        })
      })]
    })
  });
});